import Swal from "sweetalert2";
import { TextDecoder } from "text-encoding";

export const validateCsv = async file => {
    const reader = new FileReader();

    const loadFile = new Promise((resolve, reject) => {
        reader.onload = resolve;
        reader.onerror = reject;
    });

    reader.readAsArrayBuffer(file);

    try {
        await loadFile;

        const data = new Uint8Array(reader.result);
        let text = new TextDecoder("utf-8", { fatal: true }).decode(data);

        const lines = text.split("\n");
        const firstLine = lines[0];
        const columns = firstLine
            .split(";")
            .map(column => column.trim().replace(/(\r\n|\n|\r)/gm, ""));

        if (!firstLine.includes(";")) {
            Swal.fire(
                "Erro!",
                "O arquivo CSV deve usar ';' como separador.",
                "error"
            );
            return { isValid: false };
        }

        if (columns.length !== 2) {
            Swal.fire(
                "Erro!",
                "O arquivo deve conter duas colunas, nome e texto",
                "error"
            );
            return { isValid: false };
        }

        if (columns[0] !== "name" || columns[1] !== "text") {
            Swal.fire(
                "Erro!",
                "O arquivo deve conter duas colunas, nome e texto",
                "error"
            );
            return { isValid: false };
        }

        // Limpar e validar todas as linhas do arquivo
        const cleanedLines = [firstLine]; // Manter o cabeçalho
        
        for (let i = 1; i < lines.length; i++) {
            const line = lines[i].trim();
            if (!line) continue; // Pular linhas vazias
            
            const currentLine = line.split(";");
            const trimmedColumns = currentLine.map(col => col.trim()).filter(col => col !== "");

            if (trimmedColumns.length !== 2) {
                Swal.fire(
                    "Erro!",
                    `Erro na linha ${i + 1}: A linha deve conter exatamente duas colunas (nome e texto). Encontradas ${trimmedColumns.length} colunas.`,
                    "error"
                );
                return { isValid: false };
            }

            // Adicionar linha válida ao array de linhas limpas
            cleanedLines.push(`${trimmedColumns[0]};${trimmedColumns[1]}`);
        }

        // Criar novo conteúdo do CSV com as linhas válidas
        const cleanedContent = cleanedLines.join("\n");
        
        // Criar novo arquivo com o conteúdo limpo
        const cleanedFile = new File(
            [cleanedContent], 
            file.name, 
            { type: file.type }
        );

        return {
            isValid: true,
            cleanedFile,
            cleanedContent
        };
    } catch (error) {
        if (error instanceof DOMException && error.name === "EncodingError") {
            Swal.fire(
                "Erro!",
                "O arquivo CSV deve estar codificado em UTF-8.",
                "error"
            );
        } else {
            console.error("Error reading the file:", error);
        }

        return false;
    }
};
